<script setup lang="ts">
import { broadcastChannelMessages, CULTURE, toFormattedStringDateLong } from '@/composables/helpers'
import { width } from '@/composables/windowSize'
import t from '@/i18n/translations'
import DatePicker from 'primevue/datepicker'
import { biggifyDialog } from '@/composables/windowSize'
import OccupancyPicker from './OccupancyPicker.vue'
import Dialog from 'primevue/dialog'
import { date, pets, popupVisible, rooms } from '@/store/accosbar.store'
import { computed } from 'vue'
import Checkbox from 'primevue/checkbox'
import IconField from 'primevue/iconfield'
import InputText from 'primevue/inputtext'
import { broadcasterFilterStore } from '@/store/filter.store'

const formattedDateString = computed(() => toFormattedStringDateLong())

const clickApply = () => {
  popupVisible.value = false
  broadcasterFilterStore.postMessage(broadcastChannelMessages.ACCOSBARUPDATE)
}

const clickDelete = () => {
  rooms.value = [{ adults: 2, children: 0, childrenAges: [] }]
  date.value = null
  pets.value = { hasPets: false, message: '' }
  broadcasterFilterStore.postMessage(broadcastChannelMessages.ACCOSBARUPDATE)
}
</script>

<template>
  <Dialog
    v-model:visible="popupVisible"
    class="relative w-full !border-0 bg-white md:w-auto md:max-w-[41rem]"
    modal
    pt:header:class="!p-0 w-full !block"
    :pt="biggifyDialog()"
    :closable="false"
    :draggable="false"
    :baseZIndex="999999999"
  >
    <template #header>
      <div class="flex items-center justify-between bg-black p-3 text-xl text-white md:rounded-t-lg">
        <span>{{ t(`${CULTURE}.dialog.header`) }}</span>
        <button @click="popupVisible = false" class="rounded-full stroke-white p-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="h-6 w-6"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
    </template>

    <div class="my-4 grid w-full">
      <div class="flex w-full justify-center">
        <span class="font-semibold">{{ t(`${CULTURE}.dialog.travelDate`) }}</span>
      </div>
      <div class="flex min-h-6 w-full justify-center">
        <span>{{ formattedDateString }}</span>
      </div>
    </div>
    <div class="mb-2 mt-8 flex justify-center text-[var(--p-text-color)] md:my-8">
      <DatePicker
        v-model="date"
        selectionMode="range"
        pt:root:class="w-full"
        pt:panel:class="!border-0 !p-0"
        :manualInput="false"
        :minDate="new Date(new Date().setHours(0, 0, 0, 0))"
        :numberOfMonths="width <= 768 ? 1 : 2"
        inline
      />
    </div>
    <div class="flex justify-between px-3 py-4 md:justify-normal md:px-5 md:py-0">
      <div class="my-1.5 flex items-center">
        <Checkbox v-model="pets.hasPets" inputId="checkbox" :binary="true" />
        <label for="checkbox" class="ml-2 cursor-pointer">
          {{ t(`${CULTURE}.occupancy.animals`) }}
        </label>
      </div>
      <div class="ml-6 flex items-center gap-2" v-if="pets.hasPets">
        Info:
        <IconField>
          <InputText
            size="small"
            v-model="pets.message"
            class="w-40 rounded border-[var(--p-secondary-grey)] text-[var(--p-text-color)] shadow-none placeholder:text-gray-300"
            :placeholder="t(`${CULTURE}.occupancy.petsMessagePlaceholder`)"
          />
        </IconField>
      </div>
    </div>
    <div class="grid pb-12 pt-2 text-[var(--p-text-color)] md:pb-4">
      <OccupancyPicker :roomItem="undefined" />
    </div>
    <div class="md:mt-8">
      <div class="absolute bottom-0 left-0 right-0 flex items-center justify-between bg-[var(--p-primary-grey)] px-4 py-2 text-[var(--p-text-color)]">
        <a class="h-fit cursor-pointer underline" @click="clickDelete">
          {{ t(`${CULTURE}.dialog.button.delete`) }}
        </a>
        <button class="myEnquiryButton w-fit rounded px-4 py-2" @click="clickApply">
          {{ t(`${CULTURE}.dialog.button.apply`) }}
        </button>
      </div>
    </div>
  </Dialog>
</template>
